// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import {BlockControls} from '../block-controls';
import {VeryDissatisfied} from '@app/../static/assets/icons/very-dissatisfied';
import {Dissatisfied} from '@app/../static/assets/icons/dissatisfied';
import {SomewhatDissatisfied} from '@app/../static/assets/icons/somewhat-dissatisfied';
import {Neutral} from '@app/../static/assets/icons/neutral';
import {SomewhatSatisfied} from '@app/../static/assets/icons/somewhat-satisfied';
import {Satisfied} from '@app/../static/assets/icons/satisfied';
import {VerySatisfied} from '@app/../static/assets/icons/very-satisfied';

/* Creates a mock of the widget block for the
 * Customer Effort Score (CES) to expose the
 * CXCreationModal data.
 */
export const renderInactiveCESBlock = (input) => {
    const cesBlock = get(input, ['cx_question_block']);
    const blockClassname = cx('kare-block kare-block--inactive kare-block-ces');
    const iconSize = 40;
    return (
        <section className={blockClassname}>
            <h1>{cesBlock.question}</h1>
            <section className="ces-icon-container">
                <div className="side-bar" />
                <div className="ces-icon-wrapper">
                    <div className="ces-icon danger-dark">
                        <VeryDissatisfied size={iconSize} />
                    </div>
                </div>
                <div className="ces-icon-wrapper">
                    <div className="ces-icon danger">
                        <Dissatisfied size={iconSize} />
                    </div>
                </div>
                <div className="ces-icon-wrapper">
                    <div className="ces-icon danger-light">
                        <SomewhatDissatisfied size={iconSize} />
                    </div>
                </div>
                <div className="ces-icon-wrapper">
                    <div className="ces-icon warning">
                        <Neutral size={iconSize} />
                    </div>
                </div>
                <div className="ces-icon-wrapper">
                    <div className="ces-icon warning-light">
                        <SomewhatSatisfied size={iconSize} />
                    </div>
                </div>
                <div className="ces-icon-wrapper">
                    <div className="ces-icon success-light">
                        <Satisfied size={iconSize} />
                    </div>
                </div>
                <div className="ces-icon-wrapper">
                    <div className="ces-icon success">
                        <VerySatisfied size={iconSize} />
                    </div>
                </div>
            </section>
            <section className="ces-labels">
                <div className="side-bar" />
                <span className="label negative">
                    {cesBlock.label_negative}
                </span>
                <span className="label positive">
                    {cesBlock.label_positive}
                </span>
            </section>
        </section>
    );
};

interface CESBlockFieldProps {
    index?: number;
    fields?: any;
    removeBlock?: any;
    activateBlock?: any;
    input?: any;
}

export const CESBlockField = (props: CESBlockFieldProps) => {
    const {index, fields, removeBlock, activateBlock, input} = props;
    const block = get(input, ['value']);

    return (
        <div className="ces kare-cx-block-wrapper">
            {renderInactiveCESBlock(block)}
            {index >= 0 && fields && removeBlock && (
                <BlockControls
                    index={index}
                    fields={fields}
                    removeBlock={removeBlock}
                    activateBlock={activateBlock}
                />
            )}
        </div>
    );
};
